import axiosInstance from "@/api/axios-instance";

export async function updateSessionCount(
  usage_id: string,
  new_session_count: number
) {
  const response = await axiosInstance.patch("/usage/freeSession", {
    usage_id,
    new_session_count,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("failed providing free session");
  }

  const data = response.data;
  return data;
}
